import React from "react";
import { NavLink } from "react-router-dom";
import { ListGroup, ListGroupItem } from 'reactstrap';

import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';

import MyDateRenderer from "./MyDateRenderer";
import ConfirmModal from "./ConfirmModal";
import CustomerCategoryLabel from "./CustomerCategoryLabel";

import { useDispatch, useSelector } from "react-redux";
import * as idiInspectionDashboardActions from "../actions/IdiInspectionDashboardActions";

const IdiInspectionDashboardList = (props) => {
    const dispatch = useDispatch();

    const user = useSelector((state) => state.login.user);

    const [selectedId, setSelectedId] = React.useState(0);
    const [selectedIndex, setSelectedIndex] = React.useState(-1);
    const [selectedUserId, setSelectedUserId] = React.useState(-1);
    const [showAssignMeModal, setShowAssignMeModal] = React.useState(false);

    const getLotRefNoDisplay = (item) => {
        var value = "";

        if(item.lotRefNo && item.lotRefNo.length > 0) {
            if(value.length > 0) {
                value += " | ";
            }

            value += item.lotRefNo;
        }

        if(item.sourceName && item.sourceName.length > 0) {
            if(value.length > 0) {
                value += " | ";
            }

            value += item.sourceName;
        }

        if(item.tawuniyaRefNo && item.tawuniyaRefNo.length > 0) {
            if(value.length > 0) {
                value += " | ";
            }

            value += item.tawuniyaRefNo;
        }

        if(item.baladyRefNo && item.baladyRefNo.length > 0) {
            if(value.length > 0) {
                value += " | ";
            }

            value += item.baladyRefNo;
        }

        if(item.amanaRefNo && item.amanaRefNo.length > 0) {
            if(value.length > 0) {
                value += " | ";
            }

            value += item.amanaRefNo;
        }

        return value;
    }

    const getProjectTypeDisplay = (item) => {
        var value = "";

        if(item.projectType && item.projectType.length > 0) {
            if(value.length > 0) {
                value += " | ";
            }

            value += item.projectType;
        }

        if(item.structureType && item.structureType.length > 0) {
            if(value.length > 0) {
                value += " | ";
            }

            value += item.structureType;
        }

        if(item.region && item.region.length > 0) {
            if(value.length > 0) {
                value += " | ";
            }

            value += item.region;
        }

        return value;
    }

    const onCloseModalClick = () => {
        setSelectedId(0);
        setSelectedIndex(-1);
        setSelectedUserId(-1);
        setShowAssignMeModal(false);
    }

    const assignMeInspection = (id, index) => {
        setSelectedId(id);
        setSelectedIndex(index);
        setSelectedUserId(user.id);
        setShowAssignMeModal(true);
    }

    const onAssignMeInspection = async () => {
        if(selectedId > 0 && selectedIndex >= 0 && selectedUserId > 0) {
            dispatch(idiInspectionDashboardActions.assignIdiInspection(selectedId, selectedUserId, true, props.list, selectedIndex));
        }

        onCloseModalClick();
    }

    return (
        <div className="tasks-list">
            <div className="d-flex mb-2">
                <div className="flex-grow-1">
                    <h6 className="fs-14 text-uppercase fw-semibold mb-0">{props.title} <small className={`badge ${props.titleClass} align-bottom ms-1 totaltask-badge`}>{props.list ? props.list.length : 0}</small></h6>
                </div>
            </div>
            <SimpleBar className="tasks-wrapper px-3 mx-n3" forceVisible={true} autoHide={false}>
                <div className="tasks">
                    {props.list && props.list.map(function(item, index){
                        return(
                            <div key={index} className="card tasks-box" key={index}>
                                <div className="card-body">
                                    <div className="d-flex">
                                        <h6 className="fs-15 mb-0 flex-grow-1 text-truncate task-title">
                                            <NavLink to={`/idi-inspection-edit/${item.id}`} className="text-body d-block">{item.inspectionNumber}</NavLink>
                                        </h6>
                                    </div>
                                    {item.customerName &&
                                    <p className="mb-0 fs-11 flex-grow-1 text-truncate text-dark" style={{marginBottom:0}}>
                                        {item.customerName}
                                    </p>
                                    }
                                    {item.ownerName &&
                                    <p className="mb-0 fs-11 flex-grow-1 text-truncate text-dark" style={{marginBottom:0}}>
                                        {item.ownerName}
                                    </p>
                                    }
                                    <p className="mb-0 fs-11 flex-grow-1 text-truncate text-muted" title={getLotRefNoDisplay(item)}>
                                        {getLotRefNoDisplay(item)}
                                    </p>
                                    <p className="mb-0 fs-11 flex-grow-1 text-truncate text-muted" title={getProjectTypeDisplay(item)}>
                                        {getProjectTypeDisplay(item)}
                                    </p>
                                    <div className="align-items-center">
                                        <div className="pt-1" style={{textAlign:"right"}}>
                                            <div>
                                                {(props.title === "Ready for Review") && user && user.isIdiTeamLead && !item.teamLeadUserId &&
                                                    <button type="button" className="btn btn-primary btn-icon rounded-pill ms-1" title="Assign Me"
                                                        onClick={() => assignMeInspection(item.id, index)}
                                                    >
                                                        <i className="ri-user-follow-line" />
                                                    </button>
                                                }
                                            </div>
                                            <div>
                                                <span className="badge bg-success">{item.teamLeadUserName}</span>
                                            </div>
                                            <div>
                                                <span className="badge bg-success">{item.inspectorUserName}</span>
                                            </div>
                                            <div style={{textAlign:"left"}}>
                                                {item.isRd5Report && <span className="badge bg-primary me-1">RD5</span>}
                                                {item.isRd7Report && <span className="badge bg-secondary me-1">RD7</span>}
                                                {item.isInrReport && <span className="badge bg-success me-1">INR</span>}
                                                {item.isRd3Report && <span className="badge bg-danger me-1">RD3</span>}
                                                {item.isRd6Report && <span className="badge bg-warning me-1">RD6</span>}
                                                {item.isBaladyReport && <span className="badge bg-info me-1">BALADY</span>}
                                                {item.isNoReport && <span className="badge bg-light me-1">NO REPORT</span>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer border-top-dashed" style={{paddingTop:5, paddingBottom:5}}>
                                    <div className="d-flex">
                                        <div className="flex-grow-1">
                                            <ul className="link-inline mb-0" style={{paddingLeft:0}}>
                                                <li className="list-inline-item">
                                                    <i className="ri-user-add-line align-bottom"></i> {item.addedBy} | <MyDateRenderer value={item.dateAdded} format="mm/dd/yy" />
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="flex-shrink-0">
                                            <ul className="link-inline mb-0">
                                                <li className="list-inline-item">
                                                    <i className="ri-question-answer-line align-bottom"></i> {item.commentCount}
                                                </li>
                                                <li className="list-inline-item">
                                                    <i className="ri-attachment-2 align-bottom"></i> {item.documentCount}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="progress progress-sm bg-soft-success">
                                    <div className={`progress-bar ${props.titleClass}`} style={{width: "100%"}} aria-valuenow="55" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div>
                        );
                    })}

                    {props.list && props.list.length === 0 &&
                    <div className="">
                        <div className="">
                            <div className="d-flex mb-2">
                                <h6 className="fs-15 mb-0 flex-grow-1 text-truncate task-title"><div className="text-body d-block">No {props.title} Inspections</div></h6>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </SimpleBar>

            <ConfirmModal message={"Are you sure you want to Assign the IDI Inspection?"} show={showAssignMeModal} onCloseClick={onCloseModalClick} onYesClick={onAssignMeInspection} />
        </div>
    );
};

export default IdiInspectionDashboardList;